import Cookies from '@comeon/tomcat-cookies';

/**
 * Bare minimum utility to store values in sessionStorage and alternatively in cookie.
 *
 * @param {any} key
 * @param {any} value
 */

function set(key, value) {
	const stringValue = JSON.stringify(value);
	try {
		sessionStorage.setItem(key, stringValue);
	} catch (err) {
		Cookies.set(key, stringValue);
	}
}

/**
 * @param {*} key
 */
const get = key => JSON.parse(sessionStorage.getItem(key) || Cookies.get(key) || null);

/**
 * @param {any} key
 * @returns
 */
function remove(key) {
	sessionStorage.removeItem(key);
	Cookies.remove(key);

	return get(key);
}

export default { set, get, remove };
